const STORAGE_PREFIX = "quizAttempt:lastQuestion:"

const canUseBrowserStorage = () => typeof window !== "undefined"

export const getLastQuestionIndex = (attemptId: string): number | null => {
  if (!canUseBrowserStorage()) {
    return null
  }
  const raw = window.sessionStorage.getItem(`${STORAGE_PREFIX}${attemptId}`)
  if (raw === null) {
    return null
  }
  const parsed = Number.parseInt(raw, 10)
  return Number.isNaN(parsed) ? null : parsed
}

export const setLastQuestionIndex = (
  attemptId: string,
  questionIndex: number,
) => {
  if (!canUseBrowserStorage()) {
    return
  }
  window.sessionStorage.setItem(
    `${STORAGE_PREFIX}${attemptId}`,
    questionIndex.toString(),
  )
}
